var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shown ? _c('div', {
    staticClass: "lightbox-wrapper"
  }, [_c('button', {
    staticClass: "close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("x")]), _vm.hasPrev ? _c('button', {
    staticClass: "prev-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z",
      "fill": "currentColor"
    }
  })])]) : _vm._e(), _vm.hasNext ? _c('button', {
    staticClass: "next-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z",
      "fill": "currentColor"
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "lightbox"
  }, [_c('div', {
    ref: "imagesWrapper",
    staticClass: "images-wrapper",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l(_vm.srcs, function (src) {
    return _c('PinchZoom', {
      key: src,
      attrs: {
        "limit-zoom": "99999"
      }
    }, [_c('img', {
      attrs: {
        "src": src
      }
    })]);
  }), 1)])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }